import { I } from "@angular/cdk/keycodes";
import { Injectable, Sanitizer } from "@angular/core";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Params,
  Router,
  UrlTree,
} from "@angular/router";
import { Role, RolePermission } from "../interfaces/RolePermission";
import { UserAuthentication } from "../interfaces/user-authentication";
import { ChangePasswordFormComponent } from "../system-utils/change-password-form/change-password-form.component";
import { ObjectUtil } from "../system-utils/utils/ObjectUtil";
import { DialogService } from "./dialog.service";
import { HTTPService } from "./http.service";
import { SnackbarService } from "./snackbar.service";
import { UserConfigServices } from "./user-config.services";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { NzIconService } from "ng-zorro-antd/icon";

export interface SystemProperties{
  key:string,
  value:string
}

@Injectable({
  providedIn: HTTPService,
  useValue: false,
})
export class UserAuthenticationServices {
  constructor(
    private http: HTTPService,
    public router: Router,
    private dialogServices: DialogService,
    private snackBar: SnackbarService,
    private ucs:UserConfigServices,
    private inconRegistry:MatIconRegistry,
    private nzIconService:NzIconService,
    private sanitizer:DomSanitizer,
    private mat:MatIconRegistry
  ) {
    
  }

  user: UserAuthentication = null;
  mktpdicUserAcess = [];
  mktpdicActionAcess = [];
  instancesAcessByUser = [];
  actionsByInstances = [];
  mktpUsers = [];
  usersArr = [];
  mktpCompanies = [];
  companiesArr = [];
  mktpUserCompaniesResult = [];
  companiesFromUser = [];
  codeContract: any;
  authenticated = false;
  iconLoaded  = false;
  preferencesLoaded = false;
  systemProperties:SystemProperties[] = [];


  getSystemPreferences(key:string):SystemProperties{
    return this.systemProperties.find(prop=>prop.key==key);
  }

  getAllPreferences(){

    return new Promise((resolve,reject)=>{
        this.http
          .post(
            {},
            "SystemServices/cacheParameters",
            false,
            true,
            true
          )
          .subscribe((con) => {
            this.systemProperties = con as SystemProperties[];
            this.preferencesLoaded = true;
            resolve(true);
        });
      });
  }
  
  getAuthenticated(next: ActivatedRouteSnapshot):Promise<boolean|UrlTree> {
    return this.validateUser(next).then(async (can:boolean)=>{
      let params: Params = next.queryParams;
      if (params.token) {
        let token: string = (params.token as String).split("'").join("");

        if (can) {
          this.authenticated = true;
          return true;
        } else {
          await this.loginToken(token).then((x) => {
            if ( !x ){
              return this.router.createUrlTree(['/auth'],{preserveFragment:false})
            }else{
              return true;
            }
          });
        }
      } else {
        if ( !can ){
          return this.router.createUrlTree(['/auth'],{preserveFragment:false})
        }else{
          return true;
        }
        
      }  
    });
  }

  gotoPrivacy(){
      this.router.navigate(['privacy'],{skipLocationChange:false});
  }

  async validateUser(next: ActivatedRouteSnapshot) {
    
    let canRoute = true;
    
    if (this.user != null || localStorage.getItem("user")) {
      if (this.user == null) {
        this.user = JSON.parse(localStorage.getItem("user"));
      }
      
      //this.ucs.loadConfigurationCompany(this.getCompanies());
      
      if (this.user.neverexpires != null && this.user.neverexpires == "S") {
        if ( !this.iconLoaded ){
          await this.loadSvgs();
        }

        if( !this.preferencesLoaded ){
          await this.getAllPreferences();
        }
        
        return true;
      }

      if (ObjectUtil.isNotEmpty(this.user.passexpiration)) {
        let datePassExp = new Date(this.user.passexpiration);
        let now = new Date();
        if (datePassExp.getTime() < now.getTime()) {
          localStorage.removeItem("user");
          return false;
        }
      } else {
        localStorage.removeItem("user");
        return false;
      }
    }

    if (this.user != null || localStorage.getItem("user")) {
      if (localStorage.getItem("user")) {
        this.user = JSON.parse(localStorage.getItem("user"));

        //this.ucs.loadConfigurationCompany(this.getCompanies());

        if (this.router.routerState.snapshot.url != null) {
          let url = next.url.join("");
          canRoute = this.findRoute(this.user, url);
        }

        let exp = new Date(this.user.expiration);
        let agora = new Date();

        if (exp.getTime() < agora.getTime()) {
          localStorage.removeItem("user");
          return false;
        } else {
          if ( !this.iconLoaded ){
            await this.loadSvgs();
          }

          if ( !this.preferencesLoaded){
            await this.getAllPreferences();
          }
          
          return canRoute;
        }
      }
      
      if ( !this.iconLoaded ){
        await this.loadSvgs();
      }

      if ( !this.preferencesLoaded){
        await this.getAllPreferences();
      }

      return true;
    } else {
      localStorage.removeItem("user");
      return false;
    }
  }

  findRoute(user: UserAuthentication, url: string) {
    let retorno = true;
    if (ObjectUtil.isNotEmpty(this.user.permission)) {
      this.user.permission.forEach((p: RolePermission) => {
        if (ObjectUtil.isNotEmpty(p.ROLE)) {
          let role: Role = JSON.parse(p.ROLE.toString()) as Role;
          if (ObjectUtil.isNotEmpty(role.menu)) {
            if (Array.isArray(role.menu)) {
              role.menu.forEach((menu) => {
                if (menu.route == url) {
                  retorno = menu.visible;
                  return;
                }
              });
            }
          }
        }
      });
    }

    return retorno;
  }

  async getCompanyContract(idCompany) {
    await new Promise((resolve, reject) => {
      let sqlFindCompanies = ` SELECT C.CODECONTRACT FROM MKTPCOMPANIES C WHERE C.CODECOMPANY = ${idCompany}`;

      let queryBuscaAcoes = {
        entityName: "Mktpcompanies",
        sql: sqlFindCompanies,
      };

      this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          this.mktpCompanies = con["SQL"];
          this.companiesArr = [];
          this.codeContract = null;

          if (this.mktpCompanies != null && this.mktpCompanies.length > 0) {
            this.codeContract = this.mktpCompanies[0]["CODECONTRACT"];
          }

          resolve(this.codeContract);
        });
      });
  }

  async getCompaniesAcessByUser(query, idUser) {
    await new Promise((resolve, reject) => {
      let sqlFindCompanies = ` SELECT C.CODECOMPANY, C.NAME, ISNULL(B.IDUSER,null) AS ENABLE FROM MKTPCOMPANIES C LEFT JOIN MKTPUSERCOMPANY B ON C.CODECOMPANY = B.CODECOMPANY  AND B.IDUSER = ${idUser} `;

      if (query != null) {
        if (isNaN(query)) {
          //nome
          sqlFindCompanies += ` WHERE C.NAME LIKE '%${query}%' `;
        } else {
          //codigo
          sqlFindCompanies += ` WHERE C.CODECOMPANY = '${query}' `;
        }
      }

      if ( this.user.profile != "ADMIN"){
        sqlFindCompanies += ` ${query==null? ' WHERE ': ' AND '} C.CODECOMPANY IN (
          SELECT Z.CODECOMPANY   FROM MKTPCOMPANIES Z WHERE Z.CODECOMPANY IN (${this.getContracts()} ))`
      }
      

      let queryBuscaAcoes = {
        entityName: "Mktpcompanies",
        sql: sqlFindCompanies,
      };

      this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          this.mktpCompanies = con["SQL"];
          this.companiesArr = [];

          this.mktpCompanies.forEach((m) => {
            let company = {
              name: m["NAME"],
              id: m["CODECOMPANY"],
              enable: m["ENABLE"] != null,
            };

            this.companiesArr.push(company);
          });

          resolve(this.companiesArr);
        });
    });
  }

  async getAllUsers(query, strQuery = null) {
    await new Promise((resolve, reject) => {
      let sqlFindUsers = ` SELECT U.IDUSER,U.USERNAME FROM MKTPUSER U WHERE ACTIVE='S' AND  `;

      if ( this.user.profile != "ADMIN"){
        sqlFindUsers +=` U.IDUSER IN ( SELECT IDUSER FROM MKTPUSERCONTRACT WHERE CODECONTRACT IN (${this.getContracts()}) )`
      }else{
        sqlFindUsers +=` 0 = 0 `
      }

      if (query != null) {
        if (isNaN(query)) {
          //nome
          sqlFindUsers += ` AND U.USERNAME LIKE '%${query}%' `;
        } else {
          //codigo
          sqlFindUsers += ` AND U.IDUSER = '${query}' `;
        }
      }

      if (strQuery != null) {
        if (query != null) {
          sqlFindUsers += " AND ";
        } else {
          sqlFindUsers += " AND  ";
        }

        sqlFindUsers += strQuery;
      }

      let queryBuscaAcoes = {
        entityName: "Mktpuser",
        sql: sqlFindUsers,
      };

      this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          this.mktpUsers = con["SQL"];
          this.usersArr = [];

          this.mktpUsers.forEach((m) => {
            let userObj = {
              name: m["USERNAME"],
              id: m["IDUSER"],
            };

            this.usersArr.push(userObj);
          });

          resolve(this.usersArr);
        });
    });
  }


  async getAllUsersCompany() {
    await new Promise((resolve, reject) => {
      let sqlFindUsers = ` SELECT U.IDUSER,U.USERNAME FROM MKTPUSER U WHERE ACTIVE='S' `;

      
      sqlFindUsers += " AND EXISTS ( SELECT 1 FROM MKTPUSERCOMPANY I WHERE I.IDUSER=U.IDUSER ";
      
      let companies = this.user.companylist.map(data=>data.codecompany);

      sqlFindUsers += ` AND I.CODECOMPANY IN ( ${companies.join(',')} ) )`;

      sqlFindUsers += ` AND U.IDUSER != ${this.user.iduser}`;
      
      if ( this.user.profile != "ADMIN"){
        sqlFindUsers +=` AND U.IDUSER IN ( SELECT IDUSER FROM MKTPUSERCONTRACT WHERE CODECONTRACT IN (${this.getContracts()}) )`
      }

      let queryBuscaAcoes = {
        entityName: "Mktpuser",
        sql: sqlFindUsers,
      };

      this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          this.mktpUsers = con["SQL"];
          this.usersArr = [];

          this.mktpUsers.forEach((m) => {
            let userObj = {
              name: m["USERNAME"],
              id: m["IDUSER"],
            };

            this.usersArr.push(userObj);
          });

          resolve(this.usersArr);
        });
    });
  }

  async getActionsByInstance(idInstance: any, idUser: any, query: any) {
    await new Promise((resolve, reject) => {
      let config = this.user.profile != "ADMIN" ? "ISNULL(CU.ENABLE,'N')":"'S'";

      let sqlFindActions = ` SELECT A.IDACTION, A.IDINSTANCE, A.NAME, A.EXPRESSION, ISNULL(B.ENABLE,'N') AS ENABLE, ${config}  AS CUENABLE FROM MKTPDICACTION A LEFT JOIN MKTPMENUACT B ON A.IDINSTANCE = B.IDINSTANCE AND A.IDACTION=B.IDACTION AND B.IDUSER = ${idUser}`;
      
      if ( this.user.profile != "ADMIN"){
        sqlFindActions += ` INNER JOIN (SELECT  A.IDINSTANCE,
                                                A.IDACTION, 
                                                ISNULL(B.ENABLE,'N') AS ENABLE 
                                        FROM MKTPDICACTION A INNER JOIN MKTPMENUACT B ON A.IDINSTANCE = B.IDINSTANCE AND A.IDACTION=B.IDACTION
                                        WHERE B.IDUSER = ${this.user.iduser} AND
                                        ISNULL(B.ENABLE,'N')='S'
                                        ) CU ON CU.IDINSTANCE=A.IDINSTANCE AND CU.IDACTION=A.IDACTION`
      }
      
      sqlFindActions += ` WHERE A.IDINSTANCE = ${idInstance}  `;

      if (query != null) {
        if (isNaN(query)) {
          //nome
          sqlFindActions += ` AND A.NAME LIKE '%${query}%' `;
        } else {
          //codigo
          sqlFindActions += ` AND A.IDACTION = '${query}' `;
        }
      }

      let queryBuscaAcoes = {
        entityName: "Mktpdicaction",
        sql: sqlFindActions,
      };

      this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          this.mktpdicActionAcess = con["SQL"];
          this.actionsByInstances = [];

          this.mktpdicActionAcess.forEach((m) => {
            let actionAcess = {
              name: m["NAME"],
              enable: m["ENABLE"] == "S",
              cuenable: m["CUENABLE"] == "S",
              expression: m["EXPRESSION"] == "S",
              idInstance: m["IDINSTANCE"],
              id: m["IDACTION"],
            };

            this.actionsByInstances.push(actionAcess);
          });

          resolve(this.actionsByInstances);
        });
    });
  }

  async getInstancesAcessByUser(idUser: any, query: any) {
    await new Promise((resolve, reject) => {
    
      let sqlFindInstancesAcess = ` SELECT 
                DIC.IDINSTANCE, 
                DIC.INSTANCENAME, 
                ISNULL(A.CANVIEW, 'N') AS CANVIEW, 
                ISNULL(A.CANINSERT,'N') AS CANINSERT, 
                ISNULL(A.CANDELETE,'N') AS CANDELETE, 
                ISNULL(A.CANCHANGE,'N') AS CANCHANGE, 
                ISNULL(A.CANEXPORT,'N') AS CANEXPORT, 
                ISNULL(A.CANCONFIG,'N') AS CANCONFIG,
                ${this.user.profile != "ADMIN" ? "ISNULL(CU.CANVIEW,'N')" :"'S'"} AS CUCANVIEW, 
                ${this.user.profile != "ADMIN" ? "ISNULL(CU.CANINSERT,'N')" :"'S'"} AS CUCANINSERT, 
                ${this.user.profile != "ADMIN" ? "ISNULL(CU.CANDELETE,'N')" :"'S'"} AS CUCANDELETE, 
                ${this.user.profile != "ADMIN" ? "ISNULL(CU.CANCHANGE,'N')" :"'S'"} AS CUCANCHANGE, 
                ${this.user.profile != "ADMIN" ? "ISNULL(CU.CANEXPORT,'N')" :"'S'"} AS CUCANEXPORT, 
                ${this.user.profile != "ADMIN" ? "ISNULL(CU.CANCONFIG,'N')" :"'S'"} AS CUCANCONFIG 
      FROM MKTPDIC DIC LEFT OUTER JOIN MKTPDICACESS A ON DIC.IDINSTANCE = A.IDINSTANCE AND A.IDUSER = ${idUser} `;

      if ( this.user.profile != "ADMIN"){
        sqlFindInstancesAcess += ` INNER JOIN (SELECT IDINSTANCE, CANVIEW,CANINSERT,CANCHANGE,CANDELETE,CANEXPORT,CANCONFIG FROM MKTPDICACESS A
                                        WHERE A.IDUSER = ${this.user.iduser} AND
                                        (ISNULL(A.CANVIEW,'N')='S' OR 
                                         ISNULL(A.CANINSERT,'N')='S' OR 
                                         ISNULL(A.CANCHANGE,'N')='S' OR 
                                         ISNULL(A.CANDELETE,'N')='S' OR 
                                         ISNULL(A.CANEXPORT,'N')='S' OR 
                                         ISNULL(A.CANCONFIG,'N')='S' ) 
                                         ) CU ON CU.IDINSTANCE=DIC.IDINSTANCE`
      }

      if (query != null) {
        if (isNaN(query)) {
          //nome
          sqlFindInstancesAcess += ` WHERE DIC.INSTANCENAME LIKE '%${query}%' `;
        } else {
          //codigo
          sqlFindInstancesAcess += ` WHERE DIC.IDINSTANCE = '${query}' `;
        }
      }

      
    

      let queryBuscaInstancias = {
        entityName: "Mktpdic",
        sql: sqlFindInstancesAcess,
      };

      this.http
        .post(
          queryBuscaInstancias,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          this.mktpdicUserAcess = con["SQL"];
          this.instancesAcessByUser = [];

          this.mktpdicUserAcess.forEach((m) => {
            let instanceAcess = {
              name: m["INSTANCENAME"],
              view: m["CANVIEW"] == "S",
              change: m["CANCHANGE"] == "S",
              insert: m["CANINSERT"] == "S",
              delete: m["CANDELETE"] == "S",
              export: m["CANEXPORT"] == "S",
              config: m["CANCONFIG"] == "S",
              cuview: m["CUCANVIEW"] == "S",
              cuchange: m["CUCANCHANGE"] == "S",
              cuinsert: m["CUCANINSERT"] == "S",
              cudelete: m["CUCANDELETE"] == "S",
              cuexport: m["CUCANEXPORT"] == "S",
              cuconfig: m["CUCANCONFIG"] == "S",
              id: m["IDINSTANCE"],
            };

            this.instancesAcessByUser.push(instanceAcess);
          });

          resolve(this.instancesAcessByUser);
        });
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.ucs.fieldProperties = [];
      let ob = {
        uid: this.user.uid,
      };

      this.http
        .postGeneric<UserAuthentication>(
          ob,
          "SecurityServices/logout",
          false,
          false
        )
        .subscribe(
          (retorno) => {
            localStorage.removeItem("user");
            localStorage.clear();
            this.router.navigate(["auth"], { skipLocationChange: true });
            resolve(this.user);
            this.iconLoaded = false;
            this.preferencesLoaded = false;
          },
          (error) => {
            localStorage.removeItem("user");
            localStorage.clear();
            this.router.navigate(["auth"], { skipLocationChange: true });
            this.iconLoaded = false;
            this.preferencesLoaded = false;
            reject(error.message);
          }
        );
    });
  }

  async updateUserCompanyConfig(codUsu, codEmp, enable) {
    await new Promise((resolve, reject) => {
      let config = {
        codUsu: codUsu,
        codEmp: codEmp,
        enable: enable ? "S" : "N",
      };

      this.http
        .post(config, "users/updateCompanyAcess", false, true, true)
        .subscribe((con) => {
          resolve("ok");
        });
    });
  }

  async syncAcessToAllCompaniesUser(codUsu) {
    await new Promise((resolve, reject) => {
      let sqlFindCompanies = ` SELECT DISTINCT(U.CODECOMPANY) AS CODECOMPANY FROM MKTPUSERCOMPANY U WHERE U.IDUSER = ${codUsu} `;

      let queryFindCompanies = {
        entityName: "Mktpusercompany",
        sql: sqlFindCompanies,
      };

      this.http
        .post(
          queryFindCompanies,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          this.mktpUserCompaniesResult = con["SQL"];

          if (this.mktpUserCompaniesResult.length > 0) {
            let userObj = {
              codUsu: codUsu,
            };

            this.http
              .post(userObj, "users/syncAcessToCompanies", false, true, true)
              .subscribe((con) => {
                this.loadPreference(resolve,false);
              });
          } else {
            this.snackBar.showError(
              "Não existe empresa vinculada ao Usuário: " + codUsu
            );
          }
        });
    });
  }

  async copyAcessFromUser(codUsuOri, usuariosDestino) {
    await new Promise((resolve, reject) => {
      let copyAcessObj = {
        codUsuOri: codUsuOri,
        usuariosDest: usuariosDestino.toString(),
      };

      this.http
        .post(copyAcessObj, "users/copyAcessFromUser", false, true, true)
        .subscribe((con) => {
          resolve("ok");
        });
    });
  }

  reloadUser() {
    return new Promise((resolve, reject) => {
      let ob = {
        entityName: "Mktpuser",
        condition: `iduser = ${this.user.iduser}`,
        row: 1,
        showImageData: true,
        showImagaDataBase64: true,
      };

      this.http.post(ob, "JsonBrokerServices/find", false, true).subscribe(
        (retorno) => {
          ob = retorno["Mktpuser"][0];

          if (ObjectUtil.isNotEmpty(ob)) {
            this.user.nome = ob["NOME"];
            this.user.useravatar = ob["USERAVATAR"];
            this.user.layout = ob["LAYOUT"];
            localStorage.setItem("user", JSON.stringify(this.user));
            this.ucs.loadConfigurationCompany(this.getCompanies());

            let obv = new Object();
            obv = {
              entityName: "Mktppref",
              condition: `name in ('mktplace.masc.edit.fields','mktp.view.anuncios.marketplace.tabs')`,
            };

            this.user.maskEditField = [];
            this.user.marketPlaceTabs = [];
            this.http
              .post(obv, "JsonBrokerServices/find", true)
              .subscribe((data) => {
                let contract = data["Mktppref"] as Object[];
                for ( var pref of contract){
                  if ( pref['NAME']=='mktplace.masc.edit.fields'){
                    let c: Object[] = JSON.parse(
                      pref["TEXT"]
                    ) as Object[];
                    c.forEach((d) => {
                      if (this.user.maskEditField == null) {
                        this.user.maskEditField = [
                          JSON.parse(JSON.stringify(d)),
                        ];
                      } else {
                        this.user.maskEditField.push(
                          JSON.parse(JSON.stringify(d))
                        );
                      }
                    });

                  }
                  
                  
                  if ( pref['NAME']=='mktp.view.anuncios.marketplace.tabs'){
                      this.user.marketPlaceTabs = JSON.parse(pref["TEXT"]) ;
                  }
                }
                localStorage.setItem("user", JSON.stringify(this.user));
                this.loadSvgs();
                this.getAllPreferences();
                resolve(this.user);
              });
          }
        },
        (error) => {
          localStorage.removeItem("user");
          reject(error.message);
        }
      );
    });
  }

 async changePassword(userInfo:object){
    return new Promise((resolve, reject) => {
    this.http
    .postGeneric<UserAuthentication>(
      userInfo,
      "SecurityServicesMFA/changePassword",
      false,
      false
    )
    .subscribe(
      (retorno) => {
        //localStorage.removeItem("user");
        //this.router.navigate(["auth"], { skipLocationChange: true });
         resolve(retorno);
      },
      (error) => {
        //localStorage.removeItem("user");
        reject(error.message);
      }
    ); });
  }


  loginToken(token: string) {
    return new Promise((resolve, reject) => {
      let ob = {
        token: token,
      };
      localStorage.removeItem("user");

      this.http
        .postGeneric<UserAuthentication>(
          ob,
          "SecurityServices/login",
          false,
          false
        )
        .subscribe(
          (retorno) => {
            this.user = retorno;
            localStorage.setItem("user", JSON.stringify(this.user));

            this.ucs.loadConfigurationCompany(this.getCompanies());

            let ob = {
              entityName: "Mktpusercompany",
              rows: 500,
              showPresentation: false,
              showRelationshipData: false,
              showRelationship: false,
              fetchSize: 0,
              condition: "this.iduser=" + this.user.iduser,
            };

            this.http
              .post(ob, "JsonBrokerServices/find", false)
              .subscribe((data) => {
                
                this.router.navigate([""], { skipLocationChange: false });
                this.user.permission = data["Mktpusercompany"];
                localStorage.setItem("user", JSON.stringify(this.user));

                let ob = new Object();
                ob = {
                  entityName: "Mktppref",
                  condition: `name in ('mktplace.masc.edit.fields','mktp.view.anuncios.marketplace.tabs')`
                };

                
                this.user.maskEditField = [];
                this.user.marketPlaceTabs = [];
                this.http
                  .post(ob, "JsonBrokerServices/find", true)
                  .subscribe((data) => {
                    let contract = data["Mktppref"] as Object[];
                    for ( var pref of contract){
                      if ( pref['NAME']=='mktplace.masc.edit.fields'){
                        let c: Object[] = JSON.parse(
                          pref["TEXT"]
                        ) as Object[];
                        c.forEach((d) => {
                          if (this.user.maskEditField == null) {
                            this.user.maskEditField = [
                              JSON.parse(JSON.stringify(d)),
                            ];
                          } else {
                            this.user.maskEditField.push(
                              JSON.parse(JSON.stringify(d))
                            );
                          }
                        });

                      }
                      
                      
                      if ( pref['NAME']=='mktp.view.anuncios.marketplace.tabs'){
                          this.user.marketPlaceTabs = JSON.parse(pref["TEXT"]) ;
                      }
                    }
                    localStorage.setItem("user", JSON.stringify(this.user));
                    this.loadSvgs();
                    this.getAllPreferences();
                    resolve(this.user);
                  });
              });
          },
          (error) => {
            localStorage.removeItem("user");
            reject(error.message);
          }
        );
    });
  }

  login(username: string, password: string, preferEmail:boolean) {
    return new Promise((resolve, reject) => {
      let ob = {
        username: username,
        password: password,
        preferEmail: preferEmail
      };

      localStorage.removeItem("user");

      let service = "SecurityServicesMFA/login";

      // if ( environment.flymode){
      //   service = "SecurityServices/login"
      // }

      this.http
        .postGeneric<UserAuthentication>(
          ob,
          service,
          false,
          false,
          false,
          false
        )
        .subscribe(
          (retorno) => {
            var paramsPass = {};
            if(retorno.requiresMFA){
              resolve(retorno);
            }else if(retorno.showEmailPhone){
              this.snackBar.showSuccess("É necessário informar o e-mail e telefone para concluir seu cadastro!");
              resolve(retorno);
            }else if(retorno.changePassword){
              paramsPass = {oldPass: password, sessionMFA: retorno.sessionMFA, userName: username, preferEmail: preferEmail };

              this.dialogServices.openGenericDialog(
                ChangePasswordFormComponent,
                paramsPass,
                (data) => {
                  if (!data) {
                    //Ainda nao sei o que fazer aqui, caso nao retorne nada.
                    localStorage.removeItem("user");
                    this.router.navigate(["auth"], {
                      skipLocationChange: true,
                    });
                    return;
                  } else {
                    //Aqui ele pode alterar a senha resolvendo o challenge de NEW_PASSWORD do primeiro login, de qualquer forma deveria solicitar o codigo MFA pra logar.
                    resolve(retorno);
                    //this.loadPreference(resolve);
                  }
                },
                () => {
                  localStorage.removeItem("user");
                  this.router.navigate(["auth"], {
                    skipLocationChange: true,
                  });
                  return;
                }
              );
            }else{            
              paramsPass = this.setupUser(retorno, resolve, paramsPass, password, username, preferEmail);
            }
          },
          (error) => {
            console.log(error)
            localStorage.removeItem("user");
            reject(error);
          }
        );
    });
  }

  private async setupUser(retorno: UserAuthentication, resolve: (value: unknown) => void, paramsPass: object, password: string, username: string, preferEmail: boolean) {
    this.user = retorno;
    
    localStorage.setItem("user", JSON.stringify(this.user));
    await this.loadSvgs();
    await this.getAllPreferences();
    
    this.ucs.loadConfigurationCompany(this.getCompanies());
    if (this.user.neverexpires != null &&
      this.user.neverexpires == "S") {
      this.loadPreference(resolve);
    } else {
      let datePassExp = new Date();
      if (this.user.passexpiration != null) {
        datePassExp = new Date(this.user.passexpiration);
      }

      let now = new Date();
      if (datePassExp.getTime() < now.getTime()) {
        //this.router.navigate(['changepassword'], { skipLocationChange: true });
        ///return;
        paramsPass = { oldPass: password, sessionMFA: null, userName: username, preferEmail: preferEmail, forcePassword: true };
        this.dialogServices.openGenericDialog(
          ChangePasswordFormComponent,
          paramsPass,
          (data) => {
            if (!data) {
              localStorage.removeItem("user");
              this.router.navigate(["auth"], {
                skipLocationChange: true,
              });
              return;
            } else {
              this.loadPreference(resolve);
            }
          },
          () => {
            localStorage.removeItem("user");
            this.router.navigate(["auth"], {
              skipLocationChange: true,
            });
            return;
          }
        );
        //return;
      } else {
        this.loadPreference(resolve);
      }
    }

    return paramsPass;
  }

  gotoLogin(){
    localStorage.removeItem("user");
    this.router.navigate(["auth"], {
      skipLocationChange: true,
    });
    return;
  }

  loginMFA(username: string, password: string, mfaCode:string, mfaSession:string, email:string, phone:string, challengeName:String, resendSMS: boolean) {
    return new Promise((resolve, reject) => {
      let ob = {
        username: username,
        password: password,
        mfaCode: mfaCode,
        resendSMS: resendSMS,
        sessionMFA: mfaSession,
        challengeName: challengeName,
        email: email,
        phone: phone,
      };

      localStorage.removeItem("user");

      this.http
        .postGeneric<UserAuthentication>(
          ob,
          "SecurityServicesMFA/loginMFA",
          false,
          false,
          false,
          false
        )
        .subscribe(
          (retorno) => {
            if(retorno.requiresMFA){ //Se por algum motivo o MFA cair, não para de funcionar.
              resolve(retorno);
            }else if(retorno.showEmailPhone){ 
              resolve(retorno);
            }else if(retorno.changePassword){
              var paramsPass = {oldPass: password, sessionMFA: retorno.sessionMFA, userName: username, mfaCode: mfaCode, challengeName: challengeName };
              this.dialogServices.openGenericDialog(
                ChangePasswordFormComponent,
                paramsPass,
                (data) => {
                  if (!data) {
                    localStorage.removeItem("user");
                    this.router.navigate(["auth"], {
                      skipLocationChange: true,
                    });
                    return;
                  } else {
                    resolve(data);
                    //this.loadPreference(resolve);
                  }
                },
                () => {
                  localStorage.removeItem("user");
                  this.router.navigate(["auth"], {
                    skipLocationChange: true,
                  });
                  return;
                }
              );

              //resolve(retorno);
            }else{                                        
              this.setupUser(retorno, resolve, paramsPass, password, username,false);            
            }
          },
          (error) => {
            localStorage.removeItem("user");
            reject(error.error.message);
          }
        );
    });
  }

  forgotPassword(username: string, password: string, mfaCode:string, mfaSession:string, challengeName:String, firstCall:string, preferEmail: boolean, expirationStr:string) {
    return new Promise((resolve, reject) => {
      let ob = {
        username: username,
        password: password,
        mfaCode: mfaCode,
        preferEmail: preferEmail,
        expiration: expirationStr,
        sessionMFA: mfaSession,
        firstCall: firstCall,
        challengeName: challengeName,        
      };

      localStorage.removeItem("user");

      this.http
        .postGeneric<UserAuthentication>(
          ob,
          "SecurityServicesMFA/forgotPassword",
          false,
          false
        )
        .subscribe(
          (retorno) => {
            if(retorno.changePassword){

              var paramsPass = {userName: username, oldPass: null, sessionMFA: mfaSession, needMFA: "S" };
              this.dialogServices.openGenericDialog(
                ChangePasswordFormComponent,
                paramsPass,
                (data) => {
                  if (data) {                    
                    resolve(data);
                  }
                },
                () => {
                  //ver oq fazer
                  return;
                }
              );

              //resolve(retorno); //Acho q nao deve estar aqui

            }else{ //Esse codigo abaixo precisa ser revisado com a implementacao do novo fluxo, ele se repete varias vezes em outros metodos e talvez pode ser reutilizado.                                        
              this.setupUser(retorno, resolve, paramsPass, password, username, preferEmail);              
            }
          },
          (error) => {
            localStorage.removeItem("user");
            reject(error.error.message);
          }
        );
    });
  }

  forcePassword(username: string, newPass: string, expirationStr:string, password: string) {
    return new Promise((resolve, reject) => {
      let ob = {
        username: username,
        password: password,
        newPassword: newPass,
        expiration: expirationStr
      };      

      this.http
        .postGeneric<UserAuthentication>(
          ob,
          "SecurityServicesMFA/forcePassword",
          false,
          false
        )
        .subscribe(
          (retorno) => {            
              resolve(retorno); //Acho q nao deve estar aqui
          },
          (error) => {            
            reject(error.error.message);
          }
        );
    });
  }



  loadPreference(resolve, navigate:boolean = true) {
    let ob = {
      entityName: "Mktpusercompany",
      rows: 500,
      showPresentation: false,
      showRelationshipData: false,
      showRelationship: false,
      fetchSize: 0,
      condition: "iduser=" + this.user.iduser,
    };

    this.http.post(ob, "JsonBrokerServices/find", false).subscribe((data) => {
      this.user.permission = data["Mktpusercompany"];
      localStorage.setItem("user", JSON.stringify(this.user));

      let ob = new Object();
      ob = {
        entityName: "Mktppref",
        condition: `name in (
          'mktplace.masc.edit.fields',
          'mktp.view.anuncios.marketplace.tabs', 
          'tempapi.languages',
          'flow.toolbox.connector',
          'flow.toolbox.artefacts'
          )`,
      };

      this.user.maskEditField = [];
      this.user.marketPlaceTabs = [];
      this.http.post(ob, "JsonBrokerServices/find", true).subscribe((data) => {
        let contract = data["Mktppref"] as Object[];
        for ( var pref of contract){
          if ( pref['NAME']=='mktplace.masc.edit.fields'){
            let c: Object[] = JSON.parse(
              pref["TEXT"]
            ) as Object[];
            c.forEach((d) => {
              if (this.user.maskEditField == null) {
                this.user.maskEditField = [
                  JSON.parse(JSON.stringify(d)),
                ];
              } else {
                this.user.maskEditField.push(
                  JSON.parse(JSON.stringify(d))
                );
              }
            });

          }
          
          if ( pref['NAME']=='mktp.view.anuncios.marketplace.tabs'){
              this.user.marketPlaceTabs = JSON.parse(pref["TEXT"]) ;
          }

          if ( pref['NAME']=='tempapi.languages'){
            localStorage.setItem('languages', pref["TEXT"]);
          }

          if ( pref['NAME']=='flow.toolbox.artefacts'){
            localStorage.setItem('flow.toolbox.artefacts', pref["TEXT"]);
          }

          if ( pref['NAME']=='flow.toolbox.connector'){
            localStorage.setItem('flow.toolbox.connector', pref["TEXT"]);
          }
        }

        localStorage.setItem("user", JSON.stringify(this.user));
        if ( navigate ){
          
          this.router.navigate([""], { skipLocationChange: false,preserveFragment:false,replaceUrl: true });
        }
        
        resolve(this.user);
      });
    });
  }

  public getCompanies(){
    return this.user.companylist.map(data=>data.codecompany).join(',');
  }

  public getContracts(){
    return this.user.companylist.map(data=>data.codecontract).join(',');
  }

  loadSvgs():Promise<boolean>{

    return new Promise((resolve,reject)=>{
      let obinfo = {
        "entityName":"Mktpicons",
        "sql":`SELECT * FROM MKTPICONS`
      }         
      
      this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(conInfo=>{
        
        let svgs =  conInfo['SQL'] as Object[];
        
        for ( var line of svgs ){
            let svgName = line['NAME'];
            let svg = line['SVG'];
            let google = line['GOOGLE'] == 'S';
            if ( google ){
              //this.loadAllGoogleIcons(svgName);
            }else{
              if (svg && String(svg).trim().length>0) {
                const trusted = this.sanitizer.bypassSecurityTrustHtml(svg);
                try {
                  this.inconRegistry.addSvgIconLiteral(svgName, trusted);
                } catch(e){
                  console.warn('Failed to register svg for', svgName, e);
                }

                try{
                  this.nzIconService.addIconLiteral("custom:"+svgName, svg);
                }catch(e){
                  console.warn('Failed to add nz icon literal for', svgName, e);
                }
              } else {
                console.warn('Skipping empty svg for', svgName);
              }
            }
            
            
        }
        this.iconLoaded = true;
        resolve(true);
      });
  
    });
    
  }

   async loadAllGoogleIcons(iconName: string) {
      try {
        // Caminho servido pelo Angular (opção 2)
        const url = `assets/material/outline/${iconName}.svg`;

        const response = await fetch(url);

        if (!response.ok) {
          console.warn(`Material icon not found: ${iconName}`);
          return;
        }

        const svgString = await response.text();

        if (!svgString || svgString.trim().length === 0) {
          console.warn(`SVG vazio ou inválido para ${iconName}`);
          return;
        }

        // Registra no NG-ZORRO
        this.nzIconService.addIconLiteral(
          `google:${iconName}`,
          svgString
        );

      } catch (e) {
        console.error(`Erro carregando Material icon: ${iconName}`, e);
      }
    }


}
